import {
    tentativePackagesFromTentatives,
    tentativeSectionsFromTentatives,
    tentativeServicesFromTentatives,
} from './tentativeHelpers.js';
import { v4 as uuidv4 } from 'uuid';

export function createRandomKey() {
    return uuidv4();
}

export function addFrontendPropertiesToTentatives(tentatives, tentativeConfig) {
    let modifiedTentatives = tentatives;
    if (tentativeConfig.type === 'lines') {
        tentativePackagesFromTentatives(tentatives).forEach((tentativePackage) => {
            addFrontendPropertiesToSingle(tentativePackage);
        });
    }
    tentativeSectionsFromTentatives(tentatives).forEach((tentativeSection) => {
        addFrontendPropertiesToSingle(tentativeSection);
    });
    tentativeServicesFromTentatives(tentatives).forEach((tentativeService) => {
        addFrontendPropertiesToSingle(tentativeService);
    });
    return modifiedTentatives;
}

export function addIndexesAsOrderToTentatives(tentatives, tentativeConfig) {
    let modifiedTentatives = tentatives;
    if (tentativeConfig.type === 'lines') {
        tentativePackagesFromTentatives(tentatives).forEach((tentativePackage, index) => {
            tentativePackage.order = index;
        });
    }
    tentativeSectionsFromTentatives(tentatives).forEach((tentativeSection, index) => {
        tentativeSection.order = index;
    });
    tentativeServicesFromTentatives(tentatives).forEach((tentativeService, index) => {
        tentativeService.order = index;
    });
    return modifiedTentatives;
}

export function addFrontendPropertiesToSingle(object) {
    object.open = true;
    object.changes = [];
    object.errors = [];
    object.random_key = createRandomKey();
}
